<div class="pb-1 ps-1 pe-2 pt-2 border rounded datastream" [formGroup]="parentFormGroup">
  @if (parentFormGroup) {
    <div class="form-check" formArrayName="dataStreamIds">
      <input class="form-check-input" type="checkbox" [id]="'tile' + dataStream.id" [value]="dataStream.id" [checked]="selected" (change)="dataStreamIdChange($event)" />
      @if (viewSetting == 'TILE') {
        <div class="tile-label">
          <label class="form-check-label d-block" [for]="'tile' + dataStream.id">
            <div class="row">
              <div [class]="{ 'col-7': dataStream.logoImageUrl || supplierContact, 'pe-0': dataStream.logoImageUrl || supplierContact, col: !(dataStream.logoImageUrl || supplierContact) }">
                <strong class="d-block fw-semibold text-overflow">{{ dataStream.supplier?.attributes?.['NAME'] }}</strong>
                @if (dataStream.supplier! | identification : 'GLN') {
                  <small class="d-block"><strong>GLN:</strong> {{ dataStream.supplier! | identification : "GLN" }}</small>
                }
                <small class="d-block"><strong>{{ "Template.DataStreamComponent.label_products" | translate }}</strong> {{ dataStream.productCount || 0 | number }}</small>
                @if (supplierContact) {
                  <button (click)="showContact()" class="btn btn-link btn-sm p-0" type="button">
                    <fa-icon icon="comment"></fa-icon>
                  </button>
                }
              </div>
              @if (dataStream.logoImageUrl) {
                <div class="col-5 logo">
                  <div class="text-end">
                    @if (dataStream.logoImageUrl) {
                      <img class="img-fluid" [src]="dataStream.logoImageUrl" />
                    }
                  </div>
                </div>
              }
            </div>
          </label>
          @if (dataStream.firstImportDate! < newMinDate) {
            <small class="d-block fw-bold text-danger text-uppercase">{{ "Template.DataStreamComponent.text_new" | translate }}</small>
          }
        </div>
      }
      @if (viewSetting == 'LIST') {
        <div class="list-label row">
          <label class="col-4" [for]="'tile' + dataStream.id">
            <strong class="d-block">{{ dataStream.supplier?.attributes?.['NAME'] }}</strong>
            @if (dataStream.supplier! | identification : 'GLN') {
              <small class="d-block"><strong>GLN:</strong> {{ dataStream.supplier! | identification : "GLN" }}</small>
            }
          </label>
          <label class="col mb-0" [for]="'tile' + dataStream.id">
            <small class="d-block"><strong>{{ "Template.DataStreamComponent.label_products" | translate }}</strong> {{ dataStream.productCount || 0 | number }}</small>
          </label>
          @if (dataStream.firstImportDate! < newMinDate) {
            <div class="col-1 text-end">
              <span class="d-block fw-bold text-danger text-uppercase">{{ "Template.DataStreamComponent.text_new" | translate }}</span>
            </div>
          }
          @if (supplierContact) {
            <div class="col-1 text-end">
              <button (click)="showContact()" class="btn btn-link btn-sm" type="button">
                <fa-icon icon="comment"></fa-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<ng-template #contactModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ "Template.DataStreamComponent.subHeader_contactForData" | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>{{ "Template.DataStreamComponent.text_contactExplanation" | translate }}</p>
    @if (supplierContact) {
      <div>
        <strong class="d-block">{{ "Template.DataStreamComponent.label_contactPerson" | translate }}</strong>
        <div>
          {{ supplierContact.firstname }}
          {{ supplierContact.lastname }}
        </div>
        <div>
          {{ "Template.DataStreamComponent.label_email" | translate }} <a href="mailto:{{ supplierContact.email }}">{{ supplierContact.email }}</a>
        </div>
        <div>{{ "Template.DataStreamComponent.text_phone" | translate : { phone: supplierContact.phone } }}</div>
      </div>
    }
  </div>
</ng-template>
